"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const category_select_component_1 = __importDefault(require("./category-select.component"));
exports.default = category_select_component_1.default;
